import getFuncByMode from '../../../utils/getFuncByMode';
import mandi from './mandi';
import chuck from './chuck';

export default getFuncByMode({
  mandi,
  chuck,
});
